<template>
    <div class="SelectFromEndpoint">
        <select ref="compelement" class="form-control" v-bind:class="Class" v-bind:name="Name" :required="Required" @input="handleInput" v-model="value">
            <option v-if="BlankFirst" value=""></option>
            <option v-for="option in UngroupedOptions" :value="option.value">{{option.text}}</option>
            <optgroup v-for="optiongroup in GroupedOptions" :label="optiongroup.ValueGroup">
                <option v-for="option in optiongroup.Options" :value="option.value">{{option.text}}</option>
            </optgroup>
        </select>
    </div>

</template>

<script>
    

    export default {
        name: "SelectFromEndpoint",
        mounted() {
            this.GetOptions();
        },
        props: [
            "value",
            "Class",
            "Required",
            "Name",
            "BlankFirst",//bool
            "OptionsGroupName",
            "OptionsGroupSpecifierLevel1",
            "OptionsGroupSpecifierLevel2"
        ],
        data: function () {
            return {
                SelectOptions: [],
            }
        },
        methods: {
            GetOptions() {
                let filters = {
                    OptionsGroupName: this.OptionsGroupName,
                    OptionsGroupSpecifierLevel1: this.OptionsGroupSpecifierLevel1,
                    OptionsGroupSpecifierLevel2: this.OptionsGroupSpecifierLevel2
                };
                this.$MasterAPI.ExecuteRequest("GET", "Core/SelectOptions", filters, this.GetOptionsSuccess, () => { }, false);
            },
            GetOptionsSuccess(response) {
                this.SelectOptions = response.data.data;
            },
            handleInput(e) {
                this.$emit('input', this.$refs.compelement.value)
            }
        },
        components: {

        },
        computed: {
            GroupedOptions: function () {
                return this.SelectOptions.filter(o => o.ValueGroup != null);
            },
            UngroupedOptions: function () {
                let res = this.SelectOptions.filter(o => o.ValueGroup == null);
                if (res.length > 0) {
                    return res[0].Options;
                } else {
                    return [];
                }
            }
        },
        
    }
</script>

<style scoped>

</style>